/* lua.js generated code 0.3.1 */

let RouteMeta = xClass("RouteMeta")
let RouteType = table(
    [1, "kHead", 1],
    [1, "kBody", 2],
    [1, "kTail", 3]
)
RouteMeta.prototype.ctor = function (r, c, dir, routeType) {
    let self = this
    // body
    self.r = r
    self.c = c
    self.dir = dir
    self.routeType = routeType
    self.old_r = r
    self.old_c = c
}
RouteMeta.prototype.isHead = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    return self.routeType === RouteType.kHead
}
RouteMeta.prototype.getRouteType = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    return self.routeType
}
RouteMeta.prototype.updateRow = function (step) {
    let self = this
    // body
    self.r = self.r - step
}
RouteMeta.prototype.transForRect = function (rec) {
    let self = this
    // body
    self.r = self.old_r - rec.x + 1
    self.c = self.old_c - rec.y + 1
}
RouteMeta.prototype.dump = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    let data = table()
    data.r = self.r
    data.c = self.c
    data.dir = self.dir
    data.routeType = self.routeType
    return data
}
RouteMeta.prototype.recover = function (data) {
    let self = this
    // body
    self.r = data.r
    self.c = data.c
    self.dir = data.dir
    self.routeType = data.routeType
}
let GummyWormMeta = xClass("GummyWormMeta")
GummyWormMeta.prototype.ctor = function () {
    let self = this
    self.routes = table()
}
GummyWormMeta.create = function (meta) {
    let self = this
    // print("GummyWormMeta:create ", meta)
    let tmMeta = GummyWormMeta.new()
    tmMeta.fromMeta(meta)
    return tmMeta
}
GummyWormMeta.prototype.fromMeta = function (meta) {
    let self = this
    self.routes = table()
    if (meta) {
        let path = meta.pathElements
        if (path && $len(path) > 0) {
            for (let _ in path) {
                let v = path[_]
                if ($null(v)) continue
                let [start_r, start_c, end_r, end_c] = [v[2], v[1], v[4], v[3]]
                if ($len(self.routes) > 0) { //-去除连接点 以免重复添加
                    let last = self.routes[$len(self.routes)]
                    if (last.r === start_r && last.c === start_c) {
                        table.remove(self.routes)
                    }
                }
                if (start_r === end_r) {
                    let k = end_c - start_c > 0 && 1 || -1
                    let $var25 = start_c,$limit26 = end_c,$step27 = k
                    for (let c = $var25; ($step27 > 0 && c <= $limit26) || ($step27 < 0 && c >= $limit26); c += $step27) {
                        let route = RouteMeta.create(start_r, c)
                        table.insert(self.routes, route)
                    }
                } else if (start_c === end_c) {
                    let k = end_r - start_r > 0 && 1 || -1
                    let $var30 = start_r,$limit31 = end_r,$step32 = k
                    for (let r = $var30; ($step32 > 0 && r <= $limit31) || ($step32 < 0 && r >= $limit31); r += $step32) {
                        let route = RouteMeta.create(r, start_c)
                        table.insert(self.routes, route)
                    }
                }
            }
            self.createLink()
        }
    }
}
GummyWormMeta.prototype.dump = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    let data = table()
    data.routes = table()
    for (let k = 1, v = self.routes[1]; v; k++, v = self.routes[k]) {
        table.insert(data.routes, v.dump())
    }
    return data
}
GummyWormMeta.prototype.recover = function (data) {
    let self = this
    // body
    self.routes = table()
    for (let k = 1, v = data.routes[1]; v; k++, v = data.routes[k]) {
        let route = TileMoveRouteMeta.new()
        route.recover(v)
        self.routes[k] = route
    }
    self.createLink()
}
GummyWormMeta.prototype.transForRect = function (rect) {
    let self = this
    // body
    for (let k = 1, v = self.routes[1]; v; k++, v = self.routes[k]) {
        v.transForRect(rect)
    }
}
GummyWormMeta.prototype.updateRow = function (step) {
    let self = this
    // body
    for (let k = 1, v = self.routes[1]; v; k++, v = self.routes[k]) {
        v.updateRow(step)
    }
}
GummyWormMeta.prototype.createLink = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    for (let k = 1, v = self.routes[1]; v; k++, v = self.routes[k]) {
        if (k === 1) {
            v.routeType = RouteType.kHead
        } else if (k === $len(self.routes)) {
            v.routeType = RouteType.kTail
        } else {
            v.routeType = RouteType.kBody
        }
        // let nextItem, preItem
        if (v.routeType === RouteType.kTail || $len(self.routes) < 2) {
            v.dir = GameItemDirection.kNone
        } else {
            let nextItem = self.routes[k + 1]
            if (nextItem.r - v.r > 0) {
                v.dir = GameItemDirection.kDown
            } else if (nextItem.r - v.r < 0) {
                v.dir = GameItemDirection.kUp
            } else if (nextItem.c - v.c > 0) {
                v.dir = GameItemDirection.kRight
            } else if (nextItem.c - v.c < 0) {
                v.dir = GameItemDirection.kLeft
            } else {
                assert(false, string.format("create link error: %d, %d, %d, %d, %d", v.r, v.c, nextItem.r, nextItem.c, v.routeType))
            }
        }
    }
}
GummyWormMeta.prototype.findRouteByPos = function (r, c, isReverse) {
    let self = this
    if (isReverse) {
        for (let _ in self.routes) {
            let v = self.routes[_]
            if ($null(v)) continue
            if (r === v.endPos.x && c === v.endPos.y) { // 在终点中找
                return v
            }
        }
    } else {
        for (let _ in self.routes) {
            let v = self.routes[_]
            if ($null(v)) continue
            if (r === v.startPos.x && c === v.startPos.y) { // 在起点中找
                return v
            }
        }
    }
    for (let _ in self.routes) {
        let v = self.routes[_]
        if ($null(v)) continue
        if (r === v.startPos.x && r === v.endPos.x && ((c - v.startPos.y) * (c - v.endPos.y) <= 0)) { // 是否在行中间
            return v
        }
        if (c === v.startPos.y && c === v.endPos.y && ((r - v.startPos.x) * (r - v.endPos.x) <= 0)) { // 是否在列中间
            return v
        }
    }
    return null
}
//--------------------------------------------------------------------------
//--------------------------------------------------------------------------
//--------------------------------------------------------------------------
//--------------------------------------------------------------------------
//--------------------------------------------------------------------------
//--------------------------------------------------------------------------
let GummyWormConfig = xClass("GummyWormConfig")
GummyWormConfig.prototype.ctor = function () {
    let self = this
    self.gummyWormCfgs = table()
}
GummyWormConfig.create = function (config) {
    let self = this
    let ret = GummyWormConfig.new()
    ret.fromConfig(config)
    return ret
}
GummyWormConfig.prototype.fromConfig = function (config) {
    let self = this
    self.gummyWormCfgs = table()
    if (type(config) === "table" && $len(config) > 0) {
        for (let _ in config) {
            let meta = config[_]
            if ($null(meta)) continue
            let tmMeta = GummyWormMeta.create(meta)
            if ($len(tmMeta.routes) > 0) {
                let [r, c] = [tmMeta.routes[1].r, tmMeta.routes[1].c]
                self.gummyWormCfgs[r + "_" + c] = tmMeta
            }
        }
    }
}
GummyWormConfig.prototype.findTileMoveMetaByPos = function (r, c) {
    let self = this
    return self.gummyWormCfgs[r + "_" + c]
}
GummyWormConfig.prototype.dump = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    let data = table()
    for (let k in self.gummyWormCfgs) {
        let v = self.gummyWormCfgs[k]
        if ($null(v)) continue
        data[k] = v.dump()
    }
    return data
}
GummyWormConfig.prototype.recover = function (data) {
    let self = this
    // body
    self.gummyWormCfgs = table()
    for (let k in data) {
        let v = data[k]
        if ($null(v)) continue
        let cfg = GummyWormMeta.new()
        cfg.recover(v)
        self.gummyWormCfgs[k] = cfg
    }
}
module.exports = GummyWormConfig
